import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import moment from "moment";

interface DayObject {
	number: number,
	date: Date,
	isCurrentMonth: boolean,
	isCurrentDay: boolean
}

@Component
export default class InputDateFormCalendar extends Vue {
	@Prop()
	public isAppear;

	private now = moment();
	private currentDate = moment(this.now).startOf("month");
	private currentMonth = moment(this.currentDate).month() + 1;
	private currentYear = this.currentDate.year();
	private currentMonthWord = this.currentDate.locale("fr").format("MMMM");
	private titleCurrentMonthWord = this.currentDate.locale("fr").format("MMMM");
	public dayList: DayObject[] = [];

	@Prop()
	public selectedDate;

	public root;

	public modeMini = false;

	public mounted(): void {
		this.dayList = this.setDayList();
		this.root = <HTMLDivElement> this.$refs.root;

		this.checkModeMini();

		window.addEventListener("resize", () => {
			this.checkModeMini();
		}, true);
	}

	private setDayList(): DayObject[] {
		const firstDayOfMonth = moment(this.currentDate).startOf("month");
		const lastDayOfMonth = firstDayOfMonth.clone().endOf("month");

		const firstDayOfCal = firstDayOfMonth.clone().startOf("week");
		const lastDayOfCal = lastDayOfMonth.clone().endOf("week");

		const temp = firstDayOfCal.clone();
		const days = [temp.toDate()];
		const dayList: DayObject[] = [];

		while (temp.isBefore(lastDayOfCal) && days.length < 42) {
			temp.add(1, "day");
			days.push(temp.toDate());
		}
		while (days.length < 42) {
			temp.add(1, "day");
			days.push(temp.toDate());
		}

		for (let i = 0; i < days.length; i++) {
			dayList.push({
				number: days[i].getDate(),
				date: days[i],
				isCurrentMonth: ((days[i].getMonth() + 1) === this.currentMonth),
				isCurrentDay: moment(days[i]).isSame(this.selectedDate)
			});
		}

		return dayList;
	}

	public click(date: Date): void {
		if (date.getMonth() + 1 !== this.currentMonth) {
			return;
		}

		this.selectedDate = moment(date);
		this.$emit("updateSelectedDate", moment(this.selectedDate).format("YYYY-MM-DD"));
	}

	public previous(): void {
		this.currentDate = this.currentDate.subtract(1, "months");
		this.setData();
	}

	public next(): void {
		this.currentDate = this.currentDate.add(1, "months");
		this.setData();
	}

	private setData(): void {
		this.currentMonth = moment(this.currentDate).month() + 1;
		this.currentYear = this.currentDate.year();
		this.currentMonthWord = this.currentDate.locale("fr").format((this.modeMini) ? "MMM" : "MMMM");
		this.titleCurrentMonthWord = this.currentDate.locale("fr").format("MMMM");
		this.dayList = this.setDayList();
		this.$forceUpdate();
	}

	@Watch("isAppear")
	public reset(): void {
		if (!this.isAppear) {
			setTimeout(() => {
				this.changePosisitionCalendar();
			}, 200);
		}
	}

	@Watch("selectedDate")
	private changePosisitionCalendar(): void {
		if (this.selectedDate !== undefined) {
			this.currentDate = moment(this.selectedDate).startOf("month");
		} else {
			this.currentDate = moment(this.now).startOf("month");
		}

		this.setData();
	}

	@Watch("isAppear")
	private checkModeMini(): void {
		this.modeMini = this.root.clientWidth < 250;
		this.currentMonthWord = this.currentDate.locale("fr").format((this.modeMini) ? "MMM" : "MMMM");
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/extended/InputDate/InputDateCalendar/InputDateCalendar.ts